import React, { PureComponent } from 'react';

import _ from 'underscore'

import moment from 'moment'


var ColorScheme = require('color-scheme');

var randomColor = require('randomcolor'); // import the script



function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}




export default class TimelineChart extends PureComponent {




    constructor(props) {


        super(props)


        var types = { 'panne': 0, 'indisponible': 0, 'usager': 0, 'technicien': 0, 'travaux': 0 }



        for (var type in types) {
            types[type] = this.props.data.filter(r => r.name == type).length
        }



        this.state = {
            chart: null,
            dateAxis: null,
            chartDisplay: 'normal',
            types
            //data: this.formatData(this.props.data)
        }



    }

    gen_colors = () => {
        var types = { 'panne': 'red', 'indisponible': 'black', 'usager': 'orange', 'technicien': 'green', 'travaux': 'yellow' }
        var colors = {}

        _.each(types, (v, k) => {


            colors[k] = randomColor({
                count: 12,//this.state.types[k],
                hue: v,
                luminosity: 'bright'
            });

            /*
            var scheme = new ColorScheme;
            scheme.from_hue(v)         // Start the scheme 
                .scheme('mono')     // Use the 'triade' scheme, that is, colors
                // selected from 3 points equidistant around
                // the color wheel.
                .variation('hard');   // Use the 'soft' color variation
            colors[k] = scheme.colors();
*/
        })

        return colors
    }


    formatData = (data, colors) => {

        var { types } = this.state


        return data.map((r) => {


            var rNum = Math.floor(Math.random() * colors[r.name].length)
            var color = colors[r.name][rNum];

            //delete colors[r.name][rNum]


            return {
                ...r,
                start: moment(r.start).format('DD-MM-YYYY HH:mm:ss'),
                end: moment(r.end).format('DD-MM-YYYY HH:mm:ss'),

                color: am4core.color(color),
                stroke: 'black',
                name: r.name //+ ' ' + `(${types[r.name]})`
            }
        })

    }

    /*
    shouldComponentUpdate(nextProps, nextState) {
        return JSON.stringify(nextProps.data) != JSON.stringify(this.props.data)
    }*/






    componentDidUpdate(nprops) {


        this.dateAxis.min = this.props.min.valueOf()

        this.dateAxis.max = this.props.max.valueOf()

        /*
        if (
            nprops.min != this.props.min ||
            nprops.max != this.props.max ||
            nprops.data != this.props.data
    
    
        ) {
            //this.chart.data = this.formatData(this.props.data)
    
            var chart = am4core.create("chartdiv2", am4charts.XYChart);
    
            chart.dateFormatter.inputDateFormat = "dd-MM-yyyy HH:mm:ss";
    
            const { min, max } = this.props;
    
    
            chart = this.createChart(chart,
                this.formatData(this.props.data).sort((a, b) => a.name.localeCompare(b.name)),
                min, max
            );
    
            this.chart = chart
        }
    */





    }


    componentDidMount() {


        //am4core.addLicense("CH204843208");
        am4core.options.queue = true;
        am4core.options.onlyShowOnViewport = true;


        //am4core.useTheme(am4themes_animated);

        var chart = am4core.create(this.props.id, am4charts.XYChart);

        chart.dateFormatter.inputDateFormat = "dd-MM-yyyy HH:mm:ss";

        const { min, max } = this.props;

        const sortFunc = (a, b) => {
            var sortingArr = ['indisponible', 'panne', 'usager', 'technicien', 'travaux'];
            return sortingArr.indexOf(a.name) - sortingArr.indexOf(b.name);
        }




        chart = this.createChart(chart, this.formatData(this.props.data.sort(sortFunc), this.gen_colors()), min, max)


        this.chart = chart



    }






    createChart = (chart, data, min, max) => {


        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.inversed = true;

        categoryAxis.labelFunction = function (valueText) {
            return 'dept' + '-' + valueText;
        };


        //chart.legend = new am4charts.Legend();

        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy HH:mm:ss";
        dateAxis.renderer.minGridDistance = 70;
        dateAxis.baseInterval = { count: 60, timeUnit: "minutes" };

        dateAxis.min = min.valueOf()

        dateAxis.max = max.valueOf()
        dateAxis.strictMinMax = true;
        dateAxis.renderer.tooltipLocation = 0;

        this.dateAxis = dateAxis

        var series1 = chart.series.push(new am4charts.ColumnSeries());
        series1.columns.template.width = am4core.percent(80);
        series1.columns.template.tooltipHTML = "{text}";

        series1.dataFields.openDateX = "start";
        series1.dataFields.dateX = "end";
        series1.dataFields.categoryY = "name";
        series1.columns.template.propertyFields.fill = "color";
        //series1.columns.template.propertyFields.stroke = "color";

        series1.columns.template.stroke = "black";




        series1.columns.template.strokeWidth = "1px";

        series1.columns.template.strokeOpacity = 1;

        chart.scrollbarX = new am4core.Scrollbar();

        chart.cursor = new am4charts.XYCursor();

        chart.scrollbarY = new am4core.Scrollbar();
        chart.scrollbarY.parent = chart.rightAxesContainer;


        chart.data = data
        return chart
    }





    render() {

        const { totaux } = this.props;
        return (

            <div id={this.props.id} style={{ width: "100%", height: "350px" }} />

        );
    }
}

